<template>
    <video :class="'video-js vjs-default-skin ' + (is16x9?'vjs-16-9':'') + ' vjs-big-play-centered'" controls>
        <div v-if="loading" class="text-center">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
        <div class="alert alert-info" v-if="progress !== null && progress.status === 'processing'">
            Video is being processed and will be available shortly. <button class="btn btn-default btn-xs" type="button" @click="loadVideo()">Try Again</button>
        </div>
    </video>
</template>

<script>
    window.HELP_IMPROVE_VIDEOJS = false;

    export default {
        name: 'video-player',
        props: {
            url: {default: null},
            id: {default: null},
            autoplay: {default: false},
            width: {default: '100%'},
            height: {default: ''},
            fluid: {default: false},
            is16x9: {default: true},
        },
        data() {
            return {
                player: null,
                progress: null,
                loading: false,
                lastTime: 0,
            };
        },
        methods: {
            onFirstPlay() {
                this.lastTime = this.progress.progress;
                this.player.seek(this.progress.progress);
            },
            loadVideo() {
                this.loading = true;
                let parms = {};
                if(this.id === null)
                {
                    parms.url = this.url;
                }
                else
                {
                    parms.video_id = this.id;
                    parms.url = this.id;
                }
                this.$http.post('/api/video/progress', parms).then(response => {
                    if(this.player !== null) this.player.destroy();

                    this.progress = response.data.progress;
                    this.loading = false;
                    if(this.progress.status !== 'processing')
                    {
                        let my = this;
                        this.$nextTick(() => {
                            this.player = videojs(this.$el, {
                                poster: this.progress.poster,
                                autoplay: this.autoplay,
                                width: this.width,
                                height: this.height,
                                fluid: this.fluid,
                            });
                            this.player.src({
                                src: this.progress.source,
                                type: 'application/x-mpegURL',
//                                withCredentials: true
                            });
                            this.player.currentTime(this.progress.progress);
                            this.player.on('loadedmetadata', () => {
//                                console.log(this.progress.progress);
                            });
                            this.player.on('timeupdate', () => {
                                let current = this.player.currentTime();
                                if(Math.abs(current - this.lastTime) > 10)
                                {
                                    parms.progress = current;
                                    this.lastTime = current;
                                    this.$http.post('/api/video/progress', parms);
                                }
                            });
                       /*     this.player = new Clappr.Player({
                                source: this.progress.source,
                                poster: this.progress.poster,
                                autoPlay: this.autoplay,
                                persistConfig: true,
                                height: this.height,
                                width: this.width,
                                events: {
                                    onReady() {
                                        this.listenToOnce(my.player, Clappr.Events.PLAYER_PLAY, my.onFirstPlay);
                                    },
                                    onTimeUpdate(t) {
                                        if(Math.abs(t.current - my.lastTime) > 10)
                                        {
                                            parms.progress = t.current;
                                            my.lastTime = t.current;
                                            my.$http.post('/api/video/progress', parms);
                                        }
                                    }
                                }
                            });

                            this.player.attachTo(this.$el);*/

                        });
                    }
                });
            },
        },
        watch: {
            id(newVal, oldVal) {
                if(newVal !== oldVal)
                {
                    this.loadVideo();
                }
            }
        },
        mounted() {
            this.loadVideo();
        },
        beforeDestroy() {
            if(this.player !== null)
            {
                this.player.destroy();
            }
        }
    }
</script>

<style>
    /* Fix the player container to take up 100% width and to calculate its height based on its children. */
    [data-player] {
        position: relative;
        width: 100%;
        height: auto;
        margin: 0;
    }

    /* Fix the video container to take up 100% width and to calculate its height based on its children. */
    [data-player] .container[data-container] {
        width: 100%;
        height: auto;
        position: relative;
    }

    /* Fix the media-control element to take up the entire size of the player. */
    [data-player] .media-control[data-media-control] {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    /* Fix the video element to take up 100% width and to calculate its height based on its natural aspect ratio. */
    [data-player] video {
        position: relative;
        display: block;
        width: 100%;
        height: auto;
    }
</style>